import { createSlice } from "@reduxjs/toolkit";

export const qps = createSlice({
    name: 'qps',
    initialState:{
        token:null,
        contact:'',
        userName:'',
        roles:[],
        email:'',
        isContactVerified:false,
        isEmailVerified:false
    },
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload
        },
        setContact: (state, action) => {
            state.contact = action.payload
        },
        setUserName: (state, action) => {
            state.userName = action.payload
        },
        setRoles: (state, action) => {
            state.roles = action.payload
        },
        setEmail: (state, action) => {
            state.email = action.payload
        },
        setIsContactVerified: (state, action) => {
            state.isContactVerified =  Boolean(action.payload);
        },
        setIsEmailVerified: (state, action) => {
            state.isEmailVerified =  Boolean(action.payload);
        },
        clearAuthToken: (state) => {
            state.token = null;
        },
    }
})
export const { setToken, setRoles, clearAuthToken, setUserName, setContact, setEmail,setIsEmailVerified,setIsContactVerified } = qps.actions

export default qps.reducer